class HeaderLogo extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  /**
   * Obtiene el contenido a mostrar basado en la ruta actual
   */
  getContentBasedOnRoute() {
    const currentPath = window.location.pathname;
    const logoImage = this.getAttribute('logo-image');
    const logoText = this.getAttribute('logo-text') || 'Solo Media Group';
    const forceDefault = this.hasAttribute('force-default');
    // Si tiene force-default, mostrar siempre el logo/texto por defecto con link al home
    if (forceDefault) {
      return {
        type: 'text',
        content: logoText,
        alt: logoText,
        link: '/'
      };
    }

    // Si estamos en la ruta base '/', mostrar siempre el logo
    if (currentPath === '/') {
      return {
        type: logoImage ? 'image' : 'text',
        content: logoImage || logoText,
        alt: this.getAttribute('logo-alt') || logoText,
        link: null
      };
    }

    // Si estamos en una ruta /pages/algo o /blogs/algo, mostrar el nombre de la sección
    const pagesMatch = currentPath.match(/^\/(?:pages|blogs)\/([^/]+)/);
    if (pagesMatch) {
      const pageName = pagesMatch[1];

      const processedName = this.processPageName(pageName);

      return {
        type: 'text',
        content: processedName,
        alt: processedName,
        link: null
      };
    }

    // Fallback: mostrar el logo normal
    return {
      type: logoImage ? 'image' : 'text',
      content: logoImage || logoText,
      alt: this.getAttribute('logo-alt') || logoText,
      link: null
    };
  }

  /**
   * Procesa el nombre de la página para formato de título
   */
  processPageName(pageName) {
    return pageName
      // Reemplazar guiones y guiones bajos con espacios
      .replace(/[-_]/g, ' ')
      // Capitalizar cada palabra
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  render() {
    // Preservar las clases existentes del elemento
    if (!this.className) {
      this.className = 'header-smg__logo';
    }
    
    const contentData = this.getContentBasedOnRoute();
    
    let innerContent = '';
    
    if (contentData.type === 'image') {
      innerContent = `<img src="${contentData.content}" alt="${contentData.alt}" class="header-smg__logo-image">`;
    } else {
      innerContent = `<div class="header-smg__logo-text">${contentData.content}</div>`;
    }
    
    // Si hay link, envolver el contenido en un anchor
    if (contentData.link) {
      this.innerHTML = `<a href="${contentData.link}" class="header-smg__logo-link">${innerContent}</a>`;
    } else {
      this.innerHTML = innerContent;
    }
  }
}

customElements.define('header-logo', HeaderLogo);